import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2, Rocket } from "lucide-react";

export default function PaymentResult() {
  const [sp] = useSearchParams();
  const sessionId = sp.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | failed
  const [annonceId, setAnnonceId] = useState(null);

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/annonces-boost/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); setAnnonceId(data.annonce_id); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState("failed"); return; }
      } catch { /* retry */ }
      if (++tries < 8) setTimeout(poll, 2000); else setState("failed");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="max-w-xl mx-auto px-4 py-20 text-center" data-testid="payment-result">
      {state === "checking" && (
        <><Loader2 className="mx-auto text-[#E05638] animate-spin" size={48} />
        <h1 className="mt-4 font-heading text-2xl font-bold">Confirmation du paiement…</h1>
        <p className="mt-2 text-slate-500">Merci de patienter quelques secondes.</p></>
      )}
      {state === "paid" && (
        <><CheckCircle2 className="mx-auto text-emerald-600" size={56} />
        <h1 className="mt-4 font-heading text-2xl font-extrabold">Paiement confirmé 🎉</h1>
        <p className="mt-2 text-slate-600 inline-flex items-center gap-1"><Rocket size={16} className="text-[#E05638]" /> Votre annonce est désormais en tête de liste pendant 7 jours.</p>
        <div className="mt-6 flex gap-2 justify-center">
          <Link to="/compte/mes-annonces" className="btn-shine text-white font-semibold px-5 py-2.5 rounded-xl" data-testid="payment-my-annonces">Voir mes annonces</Link>
          <Link to="/petites-annonces" className="border border-slate-300 font-semibold px-5 py-2.5 rounded-xl hover:border-[#E05638]">Toutes les annonces</Link>
        </div></>
      )}
      {state === "failed" && (
        <><XCircle className="mx-auto text-rose-500" size={56} />
        <h1 className="mt-4 font-heading text-2xl font-bold">Paiement non confirmé</h1>
        <p className="mt-2 text-slate-500">Aucun montant n'a été débité si le paiement n'a pas abouti. Vous pouvez réessayer depuis « Mes annonces ».</p>
        <Link to="/compte/mes-annonces" className="mt-6 inline-block btn-shine text-white font-semibold px-5 py-2.5 rounded-xl">Retour à mes annonces</Link></>
      )}
    </div>
  );
}
